enum Interactions {
  ProceedClick = 'proceedClick',
  AdClick = 'adClick'
};

export default Interactions;
